export enum SubmissionFunnelTypeEnum {
  DIRECT = 'direct',
  MORTGAGE_CLUB = 'mortgageClub',
  NETWORK = 'network',
}

export const NETWORK_OPTIONS = [
  'BSL Financial Services',
  'Stonebridge',
  'The Right Mortgage Network',
  'Cityplus Network',
  'Beneficial',
] as const;

export const MORTGAGE_CLUB_OPTIONS = [
  'Connect IFA',
  'Finova',
  'Brilliant Solutions',
  'Legal & General Mortgage Club',
  'TMA Club',
  'Simply Biz Club',
  'PMS Mortgage Club',
] as const;

export type MortgageClubName = typeof MORTGAGE_CLUB_OPTIONS[number];
export type NetworkName = typeof NETWORK_OPTIONS[number];

export interface IOrganisationIdsByFunnel {
  [SubmissionFunnelTypeEnum.MORTGAGE_CLUB]: Record<MortgageClubName, string>;
  [SubmissionFunnelTypeEnum.NETWORK]: Record<NetworkName, string>;
}

export const VITE_ENV_VALUES = ['development', 'production', 'staging'] as const;

export type ViteEnv = typeof VITE_ENV_VALUES[number];

export type IOrganisationIdsByEnv = Record<ViteEnv, IOrganisationIdsByFunnel>;

export const ORGANISATION_IDS_BY_ENV: IOrganisationIdsByEnv = {
  development: {
    [SubmissionFunnelTypeEnum.MORTGAGE_CLUB]: {
      'Connect IFA': 'kuktpclhegx0omywojyuuc61',
      Finova: 'vxa6elo7b1rjm4rqfs08a8gx',
      'Brilliant Solutions': 'h0o24sk31z0fpxhvgkj5rr1l',
      'Legal & General Mortgage Club': 'h54bk6257jnyj7qw76pen4ax',
      'TMA Club': 'rlmacgv6e9gcpmybmfyfsvir',
      'Simply Biz Club': 'cf3hgmpqreek1uf92t0sts8w',
      'PMS Mortgage Club': 'xgod3s7fpbblxl8zv7izqwty',
    },
    [SubmissionFunnelTypeEnum.NETWORK]: {
      'BSL Financial Services': 'aetugvqpyrdvbnhff2cqfsft',
      Stonebridge: 'flyqmecnyj1fmvut1mx5j6qs',
      'The Right Mortgage Network': 'hn0uys0wq9a4pj8tc9v8qq80',
      'Cityplus Network': 'myi3xgkwbjcj32d1di6ig22d',
      Beneficial: 'ww4hec3undtoojavps5506wh',
    },
  },
  production: {
    [SubmissionFunnelTypeEnum.MORTGAGE_CLUB]: {
      'Connect IFA': 'xd534e9g5zrh7m10e7vcmrzw',
      Finova: 'ywggwk45ppjq5t3seerqfuzp',
      'Brilliant Solutions': 'ds3q3rdng70jxhbnvzqjbsxy',
      'Legal & General Mortgage Club': 'llgf63yuie6nrxbioxee7smr',
      'TMA Club': 'lkmqowwtg5o2yj1xg6ffz4cm',
      'Simply Biz Club': 'g70nhe636xhqyqcfblhs10b4',
      'PMS Mortgage Club': 'q9bhyn6xq1yekeq2msvujhgo',
    },
    [SubmissionFunnelTypeEnum.NETWORK]: {
      'BSL Financial Services': 'jcmfghs8ak3rujbbtyimg0b7',
      Stonebridge: 'vdg8i42dofgeobs0v1nnslfh',
      'The Right Mortgage Network': 'j13rhcccqkv1it03bl5zehsd',
      'Cityplus Network': 'h94tr71rvnjt5nxi05jf2o9z',
      Beneficial: 'u0v6x32th9s61wdf89wp06qo',
    },
  },
  staging: {
    [SubmissionFunnelTypeEnum.MORTGAGE_CLUB]: {
      'Connect IFA': 'b4realt9minuyguenryb5d0w',
      Finova: 'bk8piy72gf7bnwmjg0r6cfbw',
      'Brilliant Solutions': 'ha87idyxppiy3aphzjqjumzn',
      'Legal & General Mortgage Club': 'gpti2i1idjnje853sev09q23',
      'TMA Club': 'f0fgkyn88otqiz1x1pr136je',
      'Simply Biz Club': 'de1i4hpihsk2xuvzb3odihnt',
      'PMS Mortgage Club': 'xa1w3yihix3dzd6xq2mos9dw',
    },
    [SubmissionFunnelTypeEnum.NETWORK]: {
      'BSL Financial Services': 'jwhiol2684kynbkbunvmwm32',
      Stonebridge: 'psxkeqv6qx11ifxj8nmvg9ym',
      'The Right Mortgage Network': 'o3ic6fp2apxvofsv4rw4owa8',
      'Cityplus Network': 'pkdikze8l0slt9gfc9k57zvs',
      Beneficial: 'ub5jule8lvxugpln0gy3xq8g',
    },
  },
};

export interface ISubmissionForm {
  submissionFunnelType: SubmissionFunnelTypeEnum | '';
  organisationName?: string | null;
}
